import { useEffect } from "react";
import ProgrammesGrid from "../components/ProgrammesGrid";

export default function Programmes() {
  useEffect(() => { document.title = "Programmes | Dutsen Kauna Foundation"; }, []);
  return (
    <div data-testid="programmes-page">
      <section className="relative bg-[#155e3f] text-white py-24 md:py-28 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1509099381441-ea3c0cf98b94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwd29tZW4lMjBhZ3JpY3VsdHVyZXxlbnwwfHx8fDE3ODI2MDk1NTN8MA&ixlib=rb-4.1.0&q=85" alt="Women entrepreneurs at a community empowerment training" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#155e3f] via-[#155e3f]/85 to-[#155e3f]/40" />
        <div className="dk-container relative">
          <span className="text-[#d6aa43] tracking-[0.3em] text-xs font-semibold uppercase">Our programmes</span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold mt-3 max-w-3xl">Many pillars. One mission.</h1>
          <p className="mt-6 text-white text-lg max-w-2xl">Each programme is designed in partnership with communities, with documented governance and field reporting.</p>
        </div>
      </section>
      <ProgrammesGrid />
    </div>
  );
}
